import React from 'react';

const IntegrationsContext = React.createContext({
  //
});

export default IntegrationsContext;
